import { render, staticRenderFns } from "./PageAudioguides.vue?vue&type=template&id=4a6a4388&"
import script from "./PageAudioguides.vue?vue&type=script&lang=js&"
export * from "./PageAudioguides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6a4388')) {
      api.createRecord('4a6a4388', component.options)
    } else {
      api.reload('4a6a4388', component.options)
    }
    module.hot.accept("./PageAudioguides.vue?vue&type=template&id=4a6a4388&", function () {
      api.rerender('4a6a4388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/audioguides/PageAudioguides.vue"
export default component.exports